import { adminAreaQueryKeys as e } from "./adminAreaQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { adminAreaApi as r } from "@maat/api-main";
//#region src/areas/admin/useReconcileAreaMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.reconcileProperties(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.list() }), i.invalidateQueries({ queryKey: ["admin-listings"] });
		}
	});
};
//#endregion
export { i as useReconcileAreaMutation };
